<script lang="ts" setup>
defineProps<{
  title: string;
  hideTitle?: string;
}>();

const song = useSongStore();
</script>

<template>
  <div
    role="group"
    :aria-label="title"
  >
    <div class="label hidden xl:block">
      <div class="label-text">
        {{ title }}
      </div>
    </div>
    <slot />
  </div>
</template>

<style scoped lang="postcss"></style>
